// src/components/ui/LoaderBackdrop.tsx
import React from "react";

export default function LoaderBackdrop({ open }: { open: boolean }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="w-10 h-10 border-4 border-base-100 border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
}
